// extracted by mini-css-extract-plugin
export default {"controls":"CommentEdit_controls__wICML","field":"CommentEdit_field__N6FRU"};